"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElapsedPercent;
function getElapsedPercent(seconds, duration) {
  if (!seconds || !duration) {
    return 0;
  }
  var parsedSeconds = parseFloat(seconds);
  var parsedDuration = parseFloat(duration);
  if (!parsedSeconds || !parsedDuration) {
    return 0;
  }
  var decimal = parseFloat((parsedSeconds / parsedDuration).toFixed(6));
  if (!decimal) {
    return 0;
  }
  return decimal * 100;
}
//# sourceMappingURL=getElapsedPercent.js.map